import { Component, ViewChild } from '@angular/core';
import { firstValueFrom, Observable, Subscription, take } from 'rxjs';
import { GenericTableComponent } from 'src/app/features/shared/features/generic-table/components/generic-table.component';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { SystemAlarmsCatalogKeys } from '../../models/SystemAlarmsCatalogKeys copy';
import { SystemAlarmService } from '../../service/SystemAlarm.service';
import { AlarmCatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/AlarmCatalogPaginationRequest';

@Component({
  selector: 'system-alarms-list',
  templateUrl: './system-alarms-list.component.html',
  styleUrls: ['./system-alarms-list.component.css']
})
export class SystemAlarmsListComponent {
  @ViewChild(GenericTableComponent) child;
    
      columnHeader: SystemAlarmsCatalogKeys = {
        IdLog: { displayName: "IdLog", filterable: false, activeFilter: null },
        CreatedIn: { displayName: "Fecha", filterable: true, activeFilter: null },
        Hour: { displayName: "Hora", filterable: false, activeFilter: null },
        Identifier: { displayName: "Identificador", filterable: true, activeFilter: null },
        TotalTime: { displayName: "Tiempo Atn", filterable: false, activeFilter: null },
        StatusAlarm: { displayName: "Estado", filterable: false, activeFilter: null },
        AlarmLogDetails: { displayName: "Detalles", filterable: false, activeFilter: null },
        Actions: { displayName: "Acciones", filterable: false, activeFilter: null },
      };
    
      catalogPaginationRequest: AlarmCatalogPaginationRequest = {
        page: 1,
        dato: "",
        getInactive: false,
        getSystem: true,
        filters: []
      }
    
      hasInactives: boolean = true;
      hasEditables: boolean = false;
      hasDeletables: boolean = true;  
      filtersRequest : FilterRequest[] = [];
      filterOptions: { [key: string]: string[] } = {};
    
      tableData$: Observable<any[]> = new Observable<any[]>();
      tableData: any[];
      controllerName: string = "SystemAlarm";
      paginador: number;
    
      subscription_getData: Subscription;
      subscription_getDataCount: Subscription;
      subscription_getDataFileterValues: Subscription;
    
      constructor(public systemAlarmCatalogService: SystemAlarmService) {
      }
    
      ngOnInit() {
        this.EndSubscriptions();
        this.getFilters();
        this.getData();
      }
    
      ngOnDestroy(): void {
        this.EndSubscriptions();
      }
    
      EndSubscriptions(){
        if(this.subscription_getData)
          this.subscription_getData.unsubscribe();
        if(this.subscription_getDataCount)
          this.subscription_getDataCount.unsubscribe();
        if(this.subscription_getDataFileterValues)
          this.subscription_getDataFileterValues.unsubscribe();
      }
    
      getFilters(){
        var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
        this.filtersRequest = filterKeys.map(key => ({
          key: key,
          value: "" 
        }));
        this.subscription_getDataFileterValues = this.systemAlarmCatalogService.getFilterValues(this.filtersRequest).subscribe(data=>{
          filterKeys.forEach(column => {
            this.filterOptions[column] = data.result.find(x => x.key == column).values;
          });
          console.log("filterValues datos",data, this.filterOptions);
        },(error)=>{
    
        });
      }
    
      async getData(){
        const [getCount, getData] = await Promise.all([
                firstValueFrom(this.systemAlarmCatalogService.getCount(this.catalogPaginationRequest).pipe(take(1))),
                firstValueFrom(this.systemAlarmCatalogService.getPage(this.catalogPaginationRequest).pipe(take(1)))
              ]);
                    
        if (getCount.isSuccess) {
          this.paginador = getCount.result[0];
        }

        if (getData.isSuccess) {
          this.tableData = getData.result;
          this.tableData.map((item) => {
            item['IsEditable'] = this.hasEditables;
            item['IsDeletable'] = this.hasDeletables;
          });
          this.child.setData(this.tableData, this.paginador);
        }

        // this.subscription_getDataCount = this.systemAlarmCatalogService.getCount(this.catalogPaginationRequest).subscribe(data=>{
        //   console.log("alarm datos",data);
        //   this.paginador = data.result[0];
        // },(error)=>{
    
        // });
        // this. subscription_getData = this.systemAlarmCatalogService.getPage(this.catalogPaginationRequest).subscribe(data=>{
        //   console.log("alarm page 1",data);
        //   if(data.isSuccess==true)
        //   {
        //     // Apply condition on edit and delete button
        //   this.tableData = data.result;
        //   this.tableData.map(item => {
        //     item['IsEditable'] = this.hasEditables;
        //     item['IsDeletable'] = this.hasDeletables;
        //   });
        //   this.child.setData(this.tableData, this.paginador);
    
        //   }
        // },(error)=>{
    
        // });
      }
}
